/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface MenuRequest
 */
export interface MenuRequest {
  /**
   *
   * @type {string}
   * @memberof MenuRequest
   */
  title: string
  /**
   *
   * @type {number}
   * @memberof MenuRequest
   */
  key: number
  /**
   *
   * @type {boolean}
   * @memberof MenuRequest
   */
  isEnabled?: boolean
  /**
   *
   * @type {string}
   * @memberof MenuRequest
   */
  slug?: string
  /**
   *
   * @type {Array<MenuRequest>}
   * @memberof MenuRequest
   */
  children?: Array<MenuRequest> | null
}

/**
 * Check if a given object implements the MenuRequest interface.
 */
export function instanceOfMenuRequest(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'title' in value
  isInstance = isInstance && 'key' in value

  return isInstance
}

export function MenuRequestFromJSON(json: any): MenuRequest {
  return MenuRequestFromJSONTyped(json, false)
}

export function MenuRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MenuRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    title: json['title'],
    key: json['key'],
    isEnabled: !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
    slug: !exists(json, 'slug') ? undefined : json['slug'],
    children: !exists(json, 'children')
      ? undefined
      : json['children'] === null
      ? null
      : (json['children'] as Array<any>).map(MenuRequestFromJSON),
  }
}

export function MenuRequestToJSON(value?: MenuRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    title: value.title,
    key: value.key,
    isEnabled: value.isEnabled,
    slug: value.slug,
    children:
      value.children === undefined
        ? undefined
        : value.children === null
        ? null
        : (value.children as Array<any>).map(MenuRequestToJSON),
  }
}
